import { render, staticRenderFns } from "./AssociatedUser.vue?vue&type=template&id=13408323&scoped=true&"
import script from "./AssociatedUser.vue?vue&type=script&lang=js&"
export * from "./AssociatedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13408323",
  null
  
)

export default component.exports